export const SUBMENU_WIDTH = 280;